(function () {
class $a3c31fda8b913dfa$var$$c38b013c361dbfdf$var$LanguageObserver {
    #lang;
    #observer;
    constructor(){
        this.#initializeObserver();
        this.#checkInitialLanguage();
    }
    static getNestedTranslation(obj, path) {
        return path.split(".").reduce((acc, part)=>acc?.[part], obj);
    }
    #checkInitialLanguage() {
        const detectedLang = this.#detectLanguageFromClass();
        this.loadLanguage(detectedLang).then();
    }
    #detectLanguageFromClass() {
        const localeClass = Array.from(document.body.classList).find((cls)=>cls.startsWith("locale-"));
        const lang = localeClass ? localeClass.replace("locale-", "") : "ru";
        return window.translations[lang] ? lang : "ru";
    }
    async loadLanguage(lang) {
        if (window.translations[lang]) this.#lang = lang;
        else this.#lang = "ru";
        await this.applyTranslations();
    }
    async applyTranslations() {
        const lang = this.#lang;
        const elements = document.querySelectorAll("[data-i18n], [data-i18n-attr]");
        elements.forEach((el)=>{
            const key = el.getAttribute("data-i18n");
            const attrKeys = el.getAttribute("data-i18n-attr");
            if (key) {
                const translation = $a3c31fda8b913dfa$var$$c38b013c361dbfdf$var$LanguageObserver.getNestedTranslation(window.translations[lang], key);
                if (translation !== undefined) this.#updateElementText(el, translation);
            }
            if (attrKeys) {
                let attrMap;
                try {
                    attrMap = JSON.parse(attrKeys);
                } catch  {
                    return;
                }
                Object.entries(attrMap).forEach(([attr, transKey])=>{
                    const attrTranslation = $a3c31fda8b913dfa$var$$c38b013c361dbfdf$var$LanguageObserver.getNestedTranslation(window.translations[lang], transKey);
                    if (attrTranslation !== undefined) el.setAttribute(attr, attrTranslation);
                });
            }
        });
    }
    #updateElementText(el, translation) {
        if (el.childNodes.length) el.childNodes.forEach((node)=>{
            if (node.nodeType === Node.TEXT_NODE) node.textContent = translation;
        });
        else el.textContent = translation;
    }
    #initializeObserver() {
        this.#observer = new MutationObserver((mutations)=>{
            mutations.forEach((mutation)=>{
                if (mutation.type === "attributes" && mutation.attributeName === "class") {
                    const detectedLang = this.#detectLanguageFromClass();
                    if (detectedLang !== this.#lang) this.loadLanguage(detectedLang).then();
                }
            });
        });
        this.#observer.observe(document.body, {
            attributes: true,
            attributeFilter: [
                "class"
            ]
        });
    }
    init({ lang: lang } = {}) {
        if (lang) this.loadLanguage(lang).then();
    }
    updateTranslations() {
        this.applyTranslations();
    }
    async loadTranslations(lang, translationLoader) {
        try {
            const translations = await translationLoader(lang);
            window.translations[lang] = translations;
            if (lang === this.#lang) await this.applyTranslations();
        } catch  {}
    }
}
var $a3c31fda8b913dfa$export$2e2bcd8739ae039 = $a3c31fda8b913dfa$var$$c38b013c361dbfdf$var$LanguageObserver;


class $a8f4e19f0ad41bfa$var$$643fcf18b2d2e76f$var$ResourceInjector {
    static #_ = this.loadedResources = new Map();
    constructor(){}
    async loadScript(jsUrl, options = {}, timeout = 10000) {
        if ($a8f4e19f0ad41bfa$var$$643fcf18b2d2e76f$var$ResourceInjector.loadedResources.has(jsUrl)) return $a8f4e19f0ad41bfa$var$$643fcf18b2d2e76f$var$ResourceInjector.loadedResources.get(jsUrl);
        const promise = new Promise((resolve)=>{
            const script = document.createElement("script");
            script.src = jsUrl;
            Object.assign(script, options);
            const timer = setTimeout(()=>{
                resolve();
            }, timeout);
            script.onload = ()=>{
                clearTimeout(timer);
                $a8f4e19f0ad41bfa$var$$643fcf18b2d2e76f$var$ResourceInjector.loadedResources.set(jsUrl, promise);
                resolve();
            };
            script.onerror = ()=>{
                clearTimeout(timer);
                $a8f4e19f0ad41bfa$var$$643fcf18b2d2e76f$var$ResourceInjector.loadedResources.delete(jsUrl);
                resolve();
            };
            document.body.appendChild(script);
        });
        $a8f4e19f0ad41bfa$var$$643fcf18b2d2e76f$var$ResourceInjector.loadedResources.set(jsUrl, promise);
        return promise;
    }
    async loadStyle(cssUrl, options = {}, timeout = 10000) {
        if ($a8f4e19f0ad41bfa$var$$643fcf18b2d2e76f$var$ResourceInjector.loadedResources.has(cssUrl)) return $a8f4e19f0ad41bfa$var$$643fcf18b2d2e76f$var$ResourceInjector.loadedResources.get(cssUrl);
        const promise = new Promise((resolve)=>{
            const link = document.createElement("link");
            link.href = cssUrl;
            link.rel = "stylesheet";
            Object.assign(link, options);
            const timer = setTimeout(()=>{
                resolve();
            }, timeout);
            link.onload = ()=>{
                clearTimeout(timer);
                $a8f4e19f0ad41bfa$var$$643fcf18b2d2e76f$var$ResourceInjector.loadedResources.set(cssUrl, promise);
                resolve();
            };
            link.onerror = ()=>{
                clearTimeout(timer);
                $a8f4e19f0ad41bfa$var$$643fcf18b2d2e76f$var$ResourceInjector.loadedResources.delete(cssUrl);
                resolve();
            };
            document.head.appendChild(link);
        });
        $a8f4e19f0ad41bfa$var$$643fcf18b2d2e76f$var$ResourceInjector.loadedResources.set(cssUrl, promise);
        return promise;
    }
}
var $a8f4e19f0ad41bfa$export$2e2bcd8739ae039 = $a8f4e19f0ad41bfa$var$$643fcf18b2d2e76f$var$ResourceInjector;


const $5fbffa87c50562b9$var$App = {
    languageObserver: null,
    initLanguageObserver () {
        this.languageObserver = new (0, $a3c31fda8b913dfa$export$2e2bcd8739ae039)();
        this.languageObserver.init();
    },
    async loadExternalResources () {
        const resourceInjector = new (0, $a8f4e19f0ad41bfa$export$2e2bcd8739ae039)();
        await resourceInjector.loadScript('/common/scripts/signup-form.js', {
            defer: true
        }, 5000);
    },
    async init () {
        await this.loadExternalResources();
        this.initLanguageObserver();
    }
};
document.addEventListener('DOMContentLoaded', ()=>$5fbffa87c50562b9$var$App.init());

})();
//# sourceMappingURL=index.79bda400.js.map
